// extracted by mini-css-extract-plugin
module.exports = {"Root":"forgotPwd_Root__Trjtm","Item":"forgotPwd_Item__1h_Rt","TextField":"forgotPwd_TextField__3_DCY","Wrong":"forgotPwd_Wrong__22fHh"};